// @flow

import _ from 'lodash';
import React from 'react';
import {
  STRIDE_CO_BRANDING_LOGO_TEAL_URL,
  STRIDE_CO_BRANDING_LOGO_URL,
  STRIDE_LOGO_TEAL_URL,
  STRIDE_LOGO_URL,
} from 'client/constants/globals';
import 'client/styles/brandLogo.scss';

type Props = {
  brandName: string,
  logoUrl: string,
  logoHref: string,
  style: Object | null,
  siteConfigs: {
    brandSiteConfig: Object,
    defaultSiteConfig: Object,
  },
  useTeal: boolean,
};

const BRAND_LOGO_URL_PATH = 'brandSiteConfig.logo.file.url';
const CO_BRANDING_LOGO_FALLBACK_PATH = 'brandSiteConfig.coBrandingLogoLarge.file.url';

const BrandLogo = (props: Props) => {
  const { brandName, logoHref, logoUrl, style, siteConfigs, useTeal = false } = props;
  const coBrandingLogoUrl = _.get(siteConfigs, CO_BRANDING_LOGO_FALLBACK_PATH);
  // logoHref default to '/' for stride and subdomain partner; co-branding partner will go to partner landing page;
  const isSubDomainPartner = _.get(siteConfigs, 'brandSiteConfig.isSubDomainPartner', false);
  const partnerLogoHref = isSubDomainPartner ? logoHref : `/partner/${brandName}`;
  const partnerLogoUrl = _.get(siteConfigs, BRAND_LOGO_URL_PATH);
  const LOGO_URL = useTeal ? STRIDE_LOGO_TEAL_URL : STRIDE_LOGO_URL;
  const CO_BRANDING_LOGO_URL = useTeal
    ? STRIDE_CO_BRANDING_LOGO_TEAL_URL
    : STRIDE_CO_BRANDING_LOGO_URL;

  // fallback for original component usage: one single co-branding image
  if (logoUrl || coBrandingLogoUrl) {
    return (
      <a
        href={logoUrl ? logoHref : partnerLogoHref}
        className="logo header-logo-container white-logo"
        style={style}>
        <img src={logoUrl || coBrandingLogoUrl} alt={`${brandName} logo`} />
      </a>
    );
  }

  if (partnerLogoUrl) {
    return (
      <a href={partnerLogoHref} className="logo header-logo-container" style={style}>
        <img className="stride-logo-img" src={CO_BRANDING_LOGO_URL} alt="Stride Health logo" />
        <img className="partner-logo-img" src={partnerLogoUrl} alt={`${brandName} logo`} />
      </a>
    );
  }

  return (
    <a href={logoHref} className="logo header-logo-container" style={style}>
      <img src={LOGO_URL} alt={`${brandName} logo`} />
    </a>
  );
};

BrandLogo.defaultProps = {
  style: null,
  logoHref: '/',
  brandName: 'stride',
  logoUrl: '',
};

export default BrandLogo;
